import { render } from "./SelectSpinner.vue?vue&type=template&id=ff6059ae&scoped=true"
import script from "./SelectSpinner.vue?vue&type=script&lang=js"
export * from "./SelectSpinner.vue?vue&type=script&lang=js"

import "./SelectSpinner.vue?vue&type=style&index=0&id=ff6059ae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff6059ae"]])

export default __exports__